import ReactPixel from 'react-facebook-pixel';

function identifyPixel(pixelId, customer_email) {
    if (!pixelId) {
        return
    }

    var advanced = {}
    if (customer_email) {
        advanced.em = customer_email
    }

    console.log("identifying pixel: ", pixelId)
    ReactPixel.init(pixelId.toString(),
        advanced,
        {
            autoConfig: true, // set pixel's autoConfig
            debug: false, // enable logs
        }
    )
}

export {identifyPixel}

// plugin-example.js
export default function facebookPixelPlugin(userConfig) {
    // return object for analytics to use
    return {
      /* All plugins require a name */
      name: 'partner-facebook-pixel',
      /* Everything else below this is optional depending on your plugin requirements */
      config: {
        whatEver: userConfig.whatEver,
        elseYouNeed: userConfig.elseYouNeed
      },
      initialize: ({ config }) => {
        // load provider script to page
      },
      page: ({ payload }) => {
        // call provider specific page tracking
      },
      track: ({ payload }) => {
        // call provider specific event tracking
        // console.log('tracking payload: ', payload)
        console.log('tracking pixel: ', payload?.properties?.pixelId)
        if (payload?.properties?.pixelId) {

            console.log("tracking event pixel: ", payload.event)
            // Keeping Subscribe
            if (payload?.properties?.type === 'subscription') {
                ReactPixel.trackSingle(payload.properties.pixelId, 
                    "Subscribe",
                    {...payload.properties}
                )
                return
            }

            console.log("GOTTA TRACK EM ALL")
            ReactPixel.trackSingle(payload.properties.pixelId, 
                payload.event,
                {...payload.properties}
            )
        }
      },
      identify: ({ payload }) => {
        // call provider specific user identify method
      },
      loaded: () => {
        // return boolean so analytics knows when it can send data to third-party
        // return !!window.myPluginLoaded
        return true
      }
    }
  }